import { IDashboardHomeCardMetricKey } from '~/src/dash/api/dashboards/home';
import { IDashboardChartMetric } from '~/src/dash/components/charts/common';
import { DensityRange1HourByMinutes } from '~/src/dash/globals/constants';
import {
  bidErrorsMetrics,
  IDashboardLiveCards,
  IDashboardSubChart,
  keyLatencyMetrics,
} from '~/src/dash/views/dashboards/DashboardHome/common/common';

export type MobileDashboardLiveCardGroup = 'demandSelected' | 'noDemandSelected';

export interface IMobileDashboardLiveConfig {
  defaultState: {
    timeRange: number;
    displayedMetricKeys: IDashboardHomeCardMetricKey[];
    activeChartMetrics: IDashboardChartMetric[];
  };
  cards: IDashboardLiveCards;
  subCharts: IDashboardSubChart[];
}

export const mobileDashboardLiveConfig: IMobileDashboardLiveConfig = {
  defaultState: {
    timeRange: DensityRange1HourByMinutes,
    displayedMetricKeys: [
      'Revenue',
      'WinningBids',
      'Impressions',
      'CPM',
      'EndpointRequests',
      'RenderRate',
    ],
    activeChartMetrics: [
      {
        key: 'Revenue',
        label: 'Revenue',
        chartColorIndex: 0,
        chartType: 'bar',
        valueType: 'integer',
      },
    ],
  },
  cards: {
    groupings: {
      noDemandSelected: [
        'Revenue',
        'WinningBids',
        'Impressions',
        'CPM',
        'EndpointRequests',
        'RenderRate',
        'CPMPerSecond',
        'EndpointRequestsECPM',
        'Auctions',
        'RenderedPodFillRate',
        'PodFillRate',
        'PodClearRate',
        'PaidPodClearRate',
        'BidRequests',
        'BidResponses',
        'BidResponseRate',
        'BidTimeoutRate',
        'FillRate',
      ],
      demandSelected: [
        'Revenue',
        'WinningBids',
        'Impressions',
        'CPM',
        'BidResponses',
        'RenderRate',
        'CPMPerSecond',
        'BidRequests',
        'BidResponseRate',
        'BidTimeoutRate',
      ],
    },
  },
  subCharts: [
    {
      title: 'Key Latencies (ms)',
      metrics: keyLatencyMetrics,
      orderedMetricKeys: ['EndpointLatency', 'AuctionLatency', 'BidderLatency'],
    },
    {
      title: 'Bid Errors',
      metrics: bidErrorsMetrics,
      orderedMetricKeys: ['BidErrors', 'BidTimeouts'],
    },
  ],
};
